"use strict";

var _slicedToArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReplayPath = void 0;

var ReplayPath = /*#__PURE__*/function () {
  function ReplayPath() {
    _classCallCheck(this, ReplayPath);
  }

  _createClass(ReplayPath, null, [{
    key: "parse",
    value: function parse(replayPathStr) {
      var _replayPathStr$split = replayPathStr.split(':'),
          _replayPathStr$split2 = _slicedToArray(_replayPathStr$split, 2),
          serializedCount = _replayPathStr$split2[0],
          serializedChanges = _replayPathStr$split2[1];

      var counts = this.parseCounts(serializedCount);
      var changes = this.parseChanges(serializedChanges);
      return this.parseOccurences(counts, changes);
    }
  }, {
    key: "stringify",
    value: function stringify(replayPath) {
      var occurences = this.countOccurences(replayPath);
      var serializedCount = this.stringifyCounts(occurences);
      var serializedChanges = this.stringifyChanges(occurences);
      return "".concat(serializedCount, ":").concat(serializedChanges);
    }
  }, {
    key: "intToB64",
    value: function intToB64(n) {
      if (n < 26) return String.fromCharCode(n + 65);
      if (n < 52) return String.fromCharCode(n + 97 - 26);
      if (n < 62) return String.fromCharCode(n + 48 - 52);
      return String.fromCharCode(n === 62 ? 43 : 47);
    }
  }, {
    key: "b64ToInt",
    value: function b64ToInt(c) {
      if (c >= 'a') return c.charCodeAt(0) - 97 + 26;
      if (c >= 'A') return c.charCodeAt(0) - 65;
      if (c >= '0') return c.charCodeAt(0) - 48 + 52;
      return c === '+' ? 62 : 63;
    }
  }, {
    key: "countOccurences",
    value: function countOccurences(replayPath) {
      return replayPath.reduce(function (counts, cur) {
        if (counts.length === 0 || counts[counts.length - 1].count === 64 || counts[counts.length - 1].value !== cur) counts.push({
          value: cur,
          count: 1
        });else counts[counts.length - 1].count += 1;
        return counts;
      }, []);
    }
  }, {
    key: "parseOccurences",
    value: function parseOccurences(counts, changes) {
      var replayPath = [];

      for (var idx = 0; idx !== counts.length; ++idx) {
        var count = counts[idx];
        var value = changes[idx];

        for (var num = 0; num !== count; ++num) {
          replayPath.push(value);
        }
      }

      return replayPath;
    }
  }, {
    key: "stringifyChanges",
    value: function stringifyChanges(occurences) {
      var serializedChanges = '';

      for (var idx = 0; idx < occurences.length; idx += 6) {
        var changesInt = occurences.slice(idx, idx + 6).reduceRight(function (prev, cur) {
          return prev * 2 + (cur.value ? 1 : 0);
        }, 0);
        serializedChanges += this.intToB64(changesInt);
      }

      return serializedChanges;
    }
  }, {
    key: "parseChanges",
    value: function parseChanges(serializedChanges) {
      var _this = this;

      var changesInt = serializedChanges.split('').map(function (c) {
        return _this.b64ToInt(c);
      });
      var changes = [];

      for (var idx = 0; idx !== changesInt.length; ++idx) {
        var current = changesInt[idx];

        for (var n = 0; n !== 6; ++n, current >>= 1) {
          changes.push(current % 2 === 1);
        }
      }

      return changes;
    }
  }, {
    key: "stringifyCounts",
    value: function stringifyCounts(occurences) {
      var _this2 = this;

      return occurences.map(function (_ref) {
        var count = _ref.count;
        return _this2.intToB64(count - 1);
      }).join('');
    }
  }, {
    key: "parseCounts",
    value: function parseCounts(serializedCount) {
      var _this3 = this;

      return serializedCount.split('').map(function (c) {
        return _this3.b64ToInt(c) + 1;
      });
    }
  }]);

  return ReplayPath;
}();

exports.ReplayPath = ReplayPath;